import { Outlet } from 'react-router-dom';

/**
 * Layout component for new visitor management UI
 * Completely separate layout from the existing VisitorRegistrationLayout
 * Renders outlet to allow nested routes to be rendered
 */
export const NewVisitorManagementLayout = (): JSX.Element => {
  return <Outlet />;
};
